import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import HeaderOne from '../../HeaderOne'
import Breadcrumb from '../../Breadcrumb';

import { 
  Package, 
  Shield,  
  CreditCard, 
  Wallet, 
  User,
  ShoppingCart,
  Heart,
  ArrowRight,
  ChevronLeft
} from 'lucide-react';
import FooterOne from '../../FooterOne';

const Dashboard = () => {
  const [currentView, setCurrentView] = useState('dashboard');
  const [selectedCard, setSelectedCard] = useState(null);

    const navigate = useNavigate();

  const cardData = [
    {
      id: 'orders',
      title: 'My Orders',
      subtitle: 'Track, return, or buy things again',
      icon: Package,
      colorClass: 'orange',
      actions: ['My Orders', 'List Orders', 'View Order', 'Track Order', 'Return/Replacement', 'View Invoice'],
      path : '/orders'
    },
    {
      id: 'security',
      title: 'My Profile',
      subtitle: 'Edit login, name, and mobile number',
      icon: Shield,
      colorClass: 'gray',
      actions: ['Profile Page', 'Edit/Update Profile']
    },
    // {
    //   id: 'payment',
    //   title: 'Payment options',
    //   subtitle: 'Edit or add payment methods',
    //   icon: CreditCard,
    //   colorClass: 'blue',
    //   actions: ['Add Payment Method', 'Edit Payment Method', 'Make Payment']
    // },
    // {
    //   id: 'wallet',
    //   title: 'My Wallet',
    //   subtitle: 'Add money to your balance',
    //   icon: Wallet,
    //   colorClass: 'orange',
    //   actions: ['My Wallet', 'Add Money', 'Claim Gift Voucher', 'Create Gift Voucher']
    // },
    {
      id: 'wishlist',
      title: 'My Wishlist',
      subtitle: 'View and manage your saved items',
      icon: Heart,
      colorClass: 'red',
      actions: ['View Products', 'Add to Wishlist', 'Remove from Wishlist']
    },
    {
      id: 'cart',
      title: 'My Cart',
      subtitle: 'Items ready for checkout',
      icon: ShoppingCart,
      colorClass: 'green',
      actions: ['View Cart', 'Checkout', 'Save for Later']
    }
  ];


   const handleCardClick = (card) => {
    // Navigate based on card id
    switch (card.id) {
      case 'security':
        navigate('/user/profile');
        break;
      case 'orders':
        navigate('/user/orders');
        break;
      case 'payment':
        navigate('/user/payment');
        break;
      case 'wallet':
        navigate('/user/wallet');
        break;
      case 'wishlist':
        navigate('/wishlist');
        break;
      case 'cart':
        navigate('/cart-one');
        break;
      default:
        navigate('/');
    }
  };

  const handleBackToDashboard = () => {
    setCurrentView('dashboard');
    setSelectedCard(null);
  };

  if (currentView === 'detail' && selectedCard) {
    return (
      <div className="dashboard">
        <div className="dashboard__container">
          <button 
            onClick={handleBackToDashboard}
            className="back-button"
          >
            <ChevronLeft size={20} />
            Back to Dashboard
          </button>
          
          <div className="detail-header">
            <div className="detail-header__content">
              <div className={`detail-header__icon ${selectedCard.colorClass}`}>
                <selectedCard.icon className="detail-header__icon-svg" />
              </div>
              <div className="detail-header__text">
                <h2 className="detail-header__title">{selectedCard.title}</h2>
                <p className="detail-header__subtitle">{selectedCard.subtitle}</p>
              </div>
            </div>
          </div>

          <div className="detail-actions">
            <h3 className="detail-actions__title">Available Actions</h3>
            <div className="detail-actions__grid">
              {selectedCard.actions.map((action, index) => (
                <div 
                  key={index}
                  className="action-item"
                >
                  <div className="action-item__content">
                    <span className="action-item__text">{action}</span>
                    <ArrowRight size={16} className="action-item__arrow" />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    
  <>
    <HeaderOne/>

    {/* Breadcrumb */}
    <Breadcrumb title={"User"} />
      
    <div className="dashboard">
      <div className="dashboard__container">
        {/* Header */}
        <div className="dashboard__header">
          <h1 className="dashboard__title">Your Account</h1>
          <p className="dashboard__subtitle">Manage your account settings and preferences</p>
        </div>

        {/* User Info Card */}
        <div className="user-info">
          <div className="user-info__content">
            <div className="user-info__avatar">
              <User className="user-info__avatar-icon" />
            </div>
            <div className="user-info__text">
              <h2 className="user-info__title">Welcome back!</h2>
              <p className="user-info__subtitle">Manage your account and preferences</p>
            </div>
          </div>
        </div>

        {/* Cards Grid */}
        <div className="cards-grid">
          {cardData.map((card) => {
            const IconComponent = card.icon;
            return (
              <div 
                key={card.id}
                onClick={() => handleCardClick(card)}
                className="card"
              >
                <div className="card__content">
                  <div className={`card__icon ${card.colorClass}`}>
                    <IconComponent className="card__icon-svg" />
                  </div>
                  <div className="card__text">
                    <h3 className="card__title">{card.title}</h3>
                    <p className="card__subtitle">{card.subtitle}</p>
                  </div>
                </div>
                <div className="card__arrow">
                  <ArrowRight size={16} />
                </div>
              </div>
            );
          })}
        </div>

        
      </div>

      <style jsx>{`
        .dashboard {
          min-height: 100vh;
          background-color: #f8fafc;
          padding: 1.5rem;
        }

        .dashboard__container {
          max-width: 1280px;
          margin: 0 auto;
        }

        .dashboard__header {
          margin-bottom: 2rem;
        }

        .dashboard__title {
          font-size: 1.875rem;
          font-weight: 700;
          color: #000000;
          margin-bottom: 0.5rem;
        }

        .dashboard__subtitle {
          color: #6b7280;
        }

        .user-info {
          background: white;
          border-radius: 0.5rem;
          box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
          padding: 1.5rem;
          margin-bottom: 2rem;
        }

        .user-info__content {
          display: flex;
          align-items: center;
        }

        .user-info__avatar {
          width: 4rem;
          height: 4rem;
          background-color: #dbeafe;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 1rem;
        }

        .user-info__avatar-icon {
          width: 2rem;
          height: 2rem;
          color: #2563eb;
        }

        .user-info__title {
          font-size: 1.25rem;
          font-weight: 600;
          color: #000000;
        }

        .user-info__subtitle {
          color: #6b7280;
        }

        .cards-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
          gap: 1.5rem;
          margin-bottom: 3rem;
        }

        .card {
          background: white;
          border-radius: 0.5rem;
          box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
          padding: 1.5rem;
          border: 1px solid #e5e7eb;
          cursor: pointer;
          transition: all 0.2s ease;
        }

        .card:hover {
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
          border-color: #93c5fd;
          transform: translateY(-1px);
        }

        .card__content {
          display: flex;
          align-items: flex-start;
          margin-bottom: 1rem;
        }

        .card__icon {
          padding: 0.75rem;
          border-radius: 0.5rem;
          margin-right: 1rem;
          flex-shrink: 0;
        }

        .card__icon.orange {
          background-color: #fed7aa;
        }

        .card__icon.blue {
          background-color: #dbeafe;
        }

        .card__icon.gray {
          background-color: #f3f4f6;
        }

        .card__icon.purple {
          background-color: #e9d5ff;
        }

        .card__icon.teal {
          background-color: #ccfbf1;
        }

        .card__icon.red {
          background-color: #fecaca;
        }

        .card__icon.green {
          background-color: #dcfce7;
        }

        .card__icon-svg {
          width: 1.5rem;
          height: 1.5rem;
        }

        .card__icon.orange .card__icon-svg {
          color: #ea580c;
        }

        .card__icon.blue .card__icon-svg {
          color: #2563eb;
        }

        .card__icon.gray .card__icon-svg {
          color: #4b5563;
        }

        .card__icon.purple .card__icon-svg {
          color: #7c3aed;
        }

        .card__icon.teal .card__icon-svg {
          color: #0d9488;
        }

        .card__icon.red .card__icon-svg {
          color: #dc2626;
        }

        .card__icon.green .card__icon-svg {
          color: #000000;
        }

        .card__text {
          flex: 1;
        }

        .card__title {
          font-weight: 600;
          color: #000000;
          margin-bottom: 0.5rem;
        }

        .card__subtitle {
          font-size: 0.875rem;
          color: #6b7280;
          line-height: 1.4;
        }

        .card__arrow {
          display: flex;
          justify-content: flex-end;
          color: #9ca3af;
        }

        .quick-actions {
          background: white;
          border-radius: 0.5rem;
          box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
          padding: 1.5rem;
        }

        .quick-actions__title {
          font-size: 1.125rem;
          font-weight: 600;
          color: #000000;
          margin-bottom: 1rem;
        }

        .quick-actions__grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
          gap: 1rem;
        }

        .quick-action {
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 1rem;
          border-radius: 0.5rem;
          border: 1px solid #e5e7eb;
          background: white;
          cursor: pointer;
          transition: all 0.2s ease;
        }

        .quick-action:hover {
          border-color: #93c5fd;
          background-color: #eff6ff;
        }

        .quick-action__icon {
          width: 1.5rem;
          height: 1.5rem;
          margin-bottom: 0.5rem;
        }

        .quick-action__icon.blue {
          color: #2563eb;
        }

        .quick-action__icon.green {
          color: #000000;
        }

        .quick-action__icon.purple {
          color: #7c3aed;
        }

        .quick-action__icon.red {
          color: #dc2626;
        }

        .quick-action__label {
          font-size: 0.875rem;
          font-weight: 500;
          color: #000000;
        }

        .back-button {
          display: flex;
          align-items: center;
          color: #2563eb;
          background: none;
          border: none;
          cursor: pointer;
          margin-bottom: 1.5rem;
          font-size: 1rem;
          transition: color 0.2s ease;
        }

        .back-button:hover {
          color: #1d4ed8;
        }

        .detail-header {
          background: white;
          border-radius: 0.5rem;
          box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
          padding: 1.5rem;
          margin-bottom: 1.5rem;
        }

        .detail-header__content {
          display: flex;
          align-items: center;
        }

        .detail-header__icon {
          padding: 0.75rem;
          border-radius: 0.5rem;
          margin-right: 1rem;
        }

        .detail-header__icon-svg {
          width: 1.5rem;
          height: 1.5rem;
        }

        .detail-header__title {
          font-size: 1.5rem;
          font-weight: 700;
          color: #000000;
        }

        .detail-header__subtitle {
          color: #6b7280;
        }

        .detail-actions {
          background: white;
          border-radius: 0.5rem;
          box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
          padding: 1.5rem;
        }

        .detail-actions__title {
          font-size: 1.125rem;
          font-weight: 600;
          color: #000000;
          margin-bottom: 1rem;
        }

        .detail-actions__grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 1rem;
        }

        .action-item {
          padding: 1rem;
          border: 1px solid #e5e7eb;
          border-radius: 0.5rem;
          cursor: pointer;
          transition: all 0.2s ease;
        }

        .action-item:hover {
          border-color: #93c5fd;
          background-color: #eff6ff;
        }

        .action-item__content {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .action-item__text {
          color: #000000;
          font-weight: 500;
        }

        .action-item__arrow {
          color: #9ca3af;
        }

        @media (max-width: 768px) {
          .dashboard {
            padding: 1rem;
          }

          .cards-grid {
            grid-template-columns: 1fr;
          }

          .quick-actions__grid {
            grid-template-columns: repeat(2, 1fr);
          }

          .detail-actions__grid {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
    </div>

    <FooterOne/>
  </>
  );
};

export default Dashboard;